up.compiler('[flash]', function(element, { closeButtonSelector }) {
  const closeButton = document.querySelector(closeButtonSelector)

  const isImportantFlash = element.classList.contains('-error')
  const timeoutInMilliseconds = isImportantFlash ? 10000 : 2000

  const timer = up.util.timer(timeoutInMilliseconds, () => {
    if (document.body.dataset.env === 'test') return

    up.destroy(element)
  })

  up.on(closeButton, 'click', () => {
    up.destroy(element, {animation: 'fade-out'})
  })

  return () => {
    clearTimeout(timer)
  }
})
